/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Kind_NormalInputs */

const en_us2_workout_logging_kind_normal = /** @type {(inputs: Workout_Logging_Kind_NormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const pt_br2_workout_logging_kind_normal = /** @type {(inputs: Workout_Logging_Kind_NormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const es_419_workout_logging_kind_normal = /** @type {(inputs: Workout_Logging_Kind_NormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const pt_pt2_workout_logging_kind_normal = /** @type {(inputs: Workout_Logging_Kind_NormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const fr_fr2_workout_logging_kind_normal = /** @type {(inputs: Workout_Logging_Kind_NormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normale`)
};

const de_de2_workout_logging_kind_normal = /** @type {(inputs: Workout_Logging_Kind_NormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

const it_it2_workout_logging_kind_normal = /** @type {(inputs: Workout_Logging_Kind_NormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normale`)
};

/**
* | output |
* | --- |
* | "Normal" |
*
* @param {Workout_Logging_Kind_NormalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_kind_normal = /** @type {((inputs?: Workout_Logging_Kind_NormalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Kind_NormalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_kind_normal(inputs)
	if (locale === "es-419") return es_419_workout_logging_kind_normal(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_kind_normal(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_kind_normal(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_kind_normal(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_kind_normal(inputs)
	return en_us2_workout_logging_kind_normal(inputs)
});
export { workout_logging_kind_normal as "workout-logging.kind_normal" }